<template>
  <div class="ratingStars">
    <span
      v-for="star in stars"
      :key="star"
      @click="rate(star)"
      :class="{'rated': star <= value, 'unrated': star > value}"
    >
      <i class="fas fa-star"></i>
    </span>
  </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            stars: [1, 2, 3, 4, 5]
        };
    },
    methods: {
        rate(star) {
            this.$emit('input', star);
        }
    }
};
</script>
